import { Link } from 'react-router-dom';

const animeCards = [
  {
    id: 'anime-001',
    title: '鬼灭之刃 无限城篇',
    status: '上映中',
    rating: 9.8,
    category: '热血战斗',
    year: 2025,
    bgClass: 'bg-primary-100/60',
    imageUrl: 'https://readdy.ai/api/search-image?query=Kimetsu%20no%20Yaiba%20anime%20key%20visual%2C%20dramatic%20demon%20slayer%20illustration%20with%20fire%20and%20water%20breathing%20effects%2C%20dark%20atmospheric%20background%2C%20high%20quality%20anime%20art%2C%20vibrant%20colors&width=600&height=800&seq=anime-grid-001&orientation=portrait',
    linkTo: '/article/article-001',
  },
  {
    id: 'anime-002',
    title: '我推的孩子 第三季',
    status: '连载中',
    rating: 9.5,
    category: '偶像演艺',
    year: 2025,
    bgClass: 'bg-secondary-100/60',
    imageUrl: 'https://readdy.ai/api/search-image?query=Oshi%20no%20Ko%20anime%20key%20visual%2C%20idol%20theme%20with%20sparkling%20stage%20lights%2C%20beautiful%20character%20designs%2C%20soft%20pink%20and%20gold%20color%20palette%2C%20high%20quality%20anime%20art&width=600&height=800&seq=anime-grid-002&orientation=portrait',
    linkTo: '/article/article-002',
  },
  {
    id: 'anime-003',
    title: '葬送的芙莉莲 第二季',
    status: '连载中',
    rating: 9.7,
    category: '奇幻治愈',
    year: 2025,
    bgClass: 'bg-background-100',
    imageUrl: 'https://readdy.ai/api/search-image?query=Frieren%20anime%20key%20visual%2C%20elf%20mage%20in%20beautiful%20fantasy%20landscape%2C%20soft%20pastel%20colors%2C%20peaceful%20atmosphere%2C%20high%20quality%20anime%20art%2C%20gentle%20lighting&width=600&height=800&seq=anime-grid-003&orientation=portrait',
    linkTo: '/article/article-003',
  },
  {
    id: 'anime-004',
    title: '药屋少女的呢喃 第二季',
    status: '连载中',
    rating: 9.4,
    category: '宫廷推理',
    year: 2025,
    bgClass: 'bg-accent-100/60',
    imageUrl: 'https://readdy.ai/api/search-image?query=Kusuriya%20no%20Hitorigoto%20anime%20key%20visual%2C%20Chinese%20palace%20setting%20with%20beautiful%20female%20apothecary%2C%20warm%20amber%20and%20gold%20tones%2C%20elegant%20historical%20costume%2C%20high%20quality%20anime%20art&width=600&height=800&seq=anime-grid-004&orientation=portrait',
    linkTo: '/article/article-004',
  },
  {
    id: 'anime-005',
    title: '咒术回战 死灭回游篇',
    status: '即将开播',
    rating: 9.6,
    category: '热血战斗',
    year: 2025,
    bgClass: 'bg-primary-100/60',
    imageUrl: 'https://readdy.ai/api/search-image?query=Jujutsu%20Kaisen%20anime%20key%20visual%2C%20intense%20battle%20scene%20with%20cursed%20energy%20effects%2C%20dark%20urban%20setting%2C%20dramatic%20lighting%2C%20high%20quality%20anime%20art%2C%20dynamic%20composition&width=600&height=800&seq=anime-grid-005&orientation=portrait',
    linkTo: '/article/article-005',
  },
  {
    id: 'anime-006',
    title: '间谍过家家 第三季',
    status: '连载中',
    rating: 9.3,
    category: '喜剧日常',
    year: 2025,
    bgClass: 'bg-secondary-100/60',
    imageUrl: 'https://readdy.ai/api/search-image?query=Spy%20x%20Family%20anime%20key%20visual%2C%20cute%20family%20portrait%20style%2C%20warm%20cozy%20atmosphere%2C%20playful%20expressions%2C%20soft%20pastel%20colors%2C%20high%20quality%20anime%20art&width=600&height=800&seq=anime-grid-006&orientation=portrait',
    linkTo: '/article/article-006',
  },
  {
    id: 'anime-007',
    title: '迷宫饭 第二季',
    status: '连载中',
    rating: 9.2,
    category: '美食冒险',
    year: 2025,
    bgClass: 'bg-background-100',
    imageUrl: 'https://readdy.ai/api/search-image?query=Dungeon%20Meshi%20anime%20key%20visual%2C%20fantasy%20cooking%20adventure%2C%20colorful%20monster%20food%20illustration%2C%20warm%20appetizing%20colors%2C%20high%20quality%20anime%20art%2C%20fun%20atmosphere&width=600&height=800&seq=anime-grid-007&orientation=portrait',
    linkTo: '/article/article-001',
  },
  {
    id: 'anime-008',
    title: '黑执事 寄宿学校篇',
    status: '已完结',
    rating: 9.1,
    category: '悬疑推理',
    year: 2024,
    bgClass: 'bg-accent-100/60',
    imageUrl: 'https://readdy.ai/api/search-image?query=Black%20Butler%20anime%20key%20visual%2C%20Victorian%20gothic%20aesthetic%2C%20elegant%20butler%20character%2C%20dark%20mysterious%20atmosphere%2C%20high%20quality%20anime%20art%2C%20dramatic%20shadows&width=600&height=800&seq=anime-grid-008&orientation=portrait',
    linkTo: '/article/article-002',
  },
];

export default function AnimeGrid() {
  return (
    <section className="w-full bg-background-50 py-14 md:py-20">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="mb-10 md:mb-14">
          <p className="text-xs font-medium tracking-widest uppercase text-foreground-400 mb-2">
            番剧大全
          </p>
          <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4">
            <div>
              <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold font-heading text-foreground-900">
                最新<span className="italic font-heading text-primary-500">番剧</span>
              </h2>
              <p className="mt-2 text-sm text-foreground-500">实时更新，不错过每一部好番</p>
            </div>
            <Link
              to="/category/hot-blooded"
              className="inline-flex items-center gap-1.5 text-sm font-medium text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap"
            >
              查看全部
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5" data-product-shop>
          {animeCards.map((anime) => (
            <Link
              key={anime.id}
              to={anime.linkTo}
              className={`group block rounded-lg overflow-hidden cursor-pointer transition-transform duration-300 hover:-translate-y-1 ${anime.bgClass}`}
            >
              <div className="relative w-full aspect-[3/4] overflow-hidden">
                <img
                  src={anime.imageUrl}
                  alt={`${anime.title} - 樱花动漫`}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                />
                <div className="absolute top-3 left-3">
                  <span className="inline-block px-2 py-0.5 rounded-full bg-background-50/90 text-foreground-700 text-xs font-medium">
                    {anime.status}
                  </span>
                </div>
                <div className="absolute top-3 right-3 flex items-center gap-1 bg-background-50/90 rounded-full px-2 py-0.5">
                  <i className="ri-star-fill text-accent-500 text-xs"></i>
                  <span className="text-xs font-medium text-foreground-700">{anime.rating}</span>
                </div>
              </div>
              <div className="p-3 md:p-4">
                <h3 className="text-sm md:text-base font-semibold font-heading text-foreground-900 line-clamp-1">
                  {anime.title}
                </h3>
                <div className="flex items-center gap-2 mt-1.5 flex-wrap">
                  <span className="text-xs text-foreground-500">{anime.category}</span>
                  <span className="text-xs text-foreground-400">·</span>
                  <span className="text-xs text-foreground-500">{anime.year}</span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}